import { Launch } from "@lightningjs/sdk";
import { appData } from "./AppData";
import { appSettings } from "./AppSettings";
import { getApp } from "./GetApp";
import { platformSettings } from "./PlatformSettings";

function startApp() {
  Launch(getApp(), appSettings, platformSettings, appData);
}

export default startApp;
